import { render, staticRenderFns } from "./writerList.vue?vue&type=template&id=197318de&scoped=true&"
import script from "./writerList.vue?vue&type=script&lang=js&"
export * from "./writerList.vue?vue&type=script&lang=js&"
import style0 from "./writerList.vue?vue&type=style&index=0&id=197318de&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197318de",
  null
  
)

export default component.exports